module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          Welcome to Insider\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Please add a name and biography to your profile so that your contacts can search and connect with you easier. \n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "to": "/editprofile"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n            Edit Profile\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCurrentUser),
      expression: "isCurrentUser"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.messagesShowing = !_vm.messagesShowing
      }
    },
    slot: "activator"
  }, [_c('v-badge', {
    attrs: {
      "right": ""
    }
  }, [(_vm.notifications.filter(function (notification) { return !notification.read; }).length > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.notifications.filter(function (notification) { return !notification.read; }).length))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("message")])], 1)], 1), _vm._v(" "), _c('v-messages', {
    ref: "messages",
    attrs: {
      "notifications": _vm.notifications
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": _vm.toggleShowContacts
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("people")])], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contacts.length > 0),
      expression: "contacts.length > 0"
    }]
  }, [_vm._l((_vm.contacts), function(contact, index) {
    return _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          _vm.$router.push('/profile/' + contact.contactID)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(contact.contactName))])], 1)
  }), _vm._v(" "), _c('v-list-tile')], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showSearch),
      callback: function($$v) {
        _vm.showSearch = $$v
      },
      expression: "showSearch"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n            Find New Contacts \n            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-search')], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCurrentUser),
      expression: "isCurrentUser"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "to": "/editprofile"
    }
  }, [_c('v-list-tile-title', [_vm._v("Edit Profile")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('br'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "text-md-center"
  }, [_c('v-avatar', {
    attrs: {
      "size": "140"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoURL,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [(_vm.user.title != null) ? _c('p', [_vm._v(" Job Title: " + _vm._s(_vm.user.title))]) : _vm._e(), _vm._v(" "), (_vm.user.organization != null) ? _c('p', [_vm._v(" Organization: " + _vm._s(_vm.user.organization))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(" About Me ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.bio))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.inviteDiag),
      callback: function($$v) {
        _vm.inviteDiag = $$v
      },
      expression: "inviteDiag"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "slot": "activator",
      "round": ""
    },
    slot: "activator"
  }, [_vm._v(" Invite Friends")]), _vm._v(" "), _c('v-card', {
    staticClass: "white",
    attrs: {
      "height": "300",
      "width": "500"
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h1', [_vm._v("Invite Friends")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-text-field', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "text",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.invite()
      }
    }
  }, [_vm._v(" Invite ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentUser && !_vm.isContact),
      expression: "!isCurrentUser && !isContact"
    }],
    attrs: {
      "round": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.connect
    }
  }, [_vm._v("Connect With " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPending),
      expression: "isPending"
    }],
    attrs: {
      "round": "",
      "disabled": ""
    }
  }, [_vm._v(" You have requested to connect with " + _vm._s(_vm.user.name) + " ")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isContact && !_vm.isPending),
      expression: "isContact && !isPending"
    }],
    attrs: {
      "round": "",
      "disabled": ""
    }
  }, [_vm._v(" You are connected with " + _vm._s(_vm.user.name) + " ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcbcbdf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Profile.vue
// module id = 89
// module chunks = 1